import React, { useEffect, useState, useMemo } from 'react';
import axios from "axios";
import {Button, Icon, Select} from "@gravity-ui/uikit";
import { Form } from "react-bootstrap";
import LoadingSpinner from "../../../components/LoadingSpinner";
import {UpdateModal, DeleteModal} from "../../../components/Modal/Modals";
import {
    getAcceptAuthConfig,
    WORKSHOPS_INFO_ENDPOINT,
    PARTNERS_OF_WORKSHOP_ENDPOINT,
    PARTNER_TYPES_ENDPOINT,
    PARTNER_TYPES_DETAIL_ENDPOINT,
    PARTNER_TYPES_REORDER_ENDPOINT,
} from "../../../api/api";
import {AddButtonMaxWidth, DeleteButtonIcon, EditButtonIcon} from "../../../components/Button/Button";
import {Link, useLocation} from "react-router-dom";
import {ChevronRight} from "@gravity-ui/icons";

const dataCache = {
    workshops: null,
    partners: new Map()
};

const DragHandle = () => (
    <div className="drag-handle" style={{
        cursor: 'grab',
        padding: '4px 8px',
        fontSize: '14px',
        color: '#666',
        userSelect: 'none',
        display: 'flex',
        alignItems: 'center',
        marginRight: '8px'
    }}>
        ⋮⋮
    </div>
);

const PartnerTypeForm = ({submitting, onSubmit, partnerData, setPartnerData, errors, setOpen}) => {
    const onChange = (e) => {
        const {name, value} = e.target;
        setPartnerData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    return (
        <Form onSubmit={onSubmit}>
            <Form.Group controlId="formPartnerTypeName">
                <Form.Label className="required">Название типа партнера</Form.Label>
                <Form.Control required
                              type="text"
                              name="name"
                              value={partnerData.name}
                              onChange={onChange}
                              autoComplete="off"
                              aria-describedby="nameHelpBlock"
                              isInvalid={!!(errors && errors.name)}/>
                <Form.Control.Feedback type="invalid">{errors && errors.name}</Form.Control.Feedback>
                <Form.Text id="nameHelpBlock" muted>
                    <strong>Например:</strong> Генеральный партнер, Информационный партнер и т.д.
                </Form.Text>
            </Form.Group>            <Form.Group controlId="formPartnerTypeDescription">
            <Form.Label>Описание</Form.Label>
            <Form.Control as="textarea"
                          rows={3}
                          name="description"
                          value={partnerData.description}
                          onChange={onChange}
                          autoComplete="off"
                          isInvalid={!!(errors && errors.description)}/>
            <Form.Control.Feedback type="invalid">{errors && errors.description}</Form.Control.Feedback>
        </Form.Group>
            <div className="line-btn-group">
                <Button view="normal" onClick={() => setOpen(false)} width="max">Отменить</Button>
                <Button view="action" type="submit" disabled={submitting} width="max">
                    {submitting ? "Сохранение..." : "Сохранить"}
                </Button>
            </div>
        </Form>
    );
};

const PartnerTypeItem = ({
                             partnerType,
                             workshopId,
                             onDelete,
                             onEdit,
                             isEditMode,
                             index,
                             onDragStart,
                             onDragEnd,
                             onDragOver,
                             onDragEnter,
                             onDrop,
                             isDragOver
                         }) => {
    const [openDelete, setOpenDelete] = useState(false);
    const [openEdit, setOpenEdit] = useState(false);
    const [editData, setEditData] = useState({
        name: partnerType.name,
        description: partnerType.description || ""
    });

    return (
        <li
            className={`bmm-card d-flex justify-content-between align-items-center mb-2 ${
                isEditMode ? 'draggable-item' : ''
            } ${isDragOver ? 'drag-over' : ''}`}
            draggable={isEditMode}
            onDragStart={(e) => onDragStart(e, index)}
            onDragEnd={onDragEnd}
            onDragOver={onDragOver}
            onDragEnter={(e) => onDragEnter(e, index)}
            onDrop={(e) => onDrop(e, index)}
            style={{
                position: 'relative',
                border: isEditMode ? '2px dashed #ddd' : '',
                borderRadius: isEditMode ? '8px' : '',
                backgroundColor: isDragOver ? '#f8f9fa' : '',
                cursor: isEditMode ? 'move' : 'default',
                transition: 'all 0.2s ease'
            }}
        >
            {isEditMode && (
                <div style={{
                    position: 'absolute',
                    top: '8px',
                    left: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px',
                    zIndex: 2
                }}>
                    <span style={{
                        fontSize: '11px',
                        color: '#666',
                        backgroundColor: '#e9ecef',
                        padding: '2px 4px',
                        borderRadius: '3px',
                        minWidth: '20px',
                        textAlign: 'center'
                    }}>
                        {index + 1}
                    </span>
                    <DragHandle />                </div>            )}

            <Link
                to={`/account/partners/${workshopId}/${partnerType.id}`}
                className="bmm-text_bold flex-grow-1 text-decoration-none d-flex align-items-center justify-content-between"
                style={{
                    color: 'inherit',
                    pointerEvents: isEditMode ? 'none' : 'auto',
                    marginLeft: isEditMode ? '60px' : '0'
                }}
            >
                <span>                    {partnerType.name}
                    {partnerType.partners.length > 0 && (
                        <span className="text-muted ml-2">({partnerType.partners.length})</span>
                    )}
                </span>
                <Icon data={ChevronRight} size={18} className="ml-2" />
            </Link>
            {!isEditMode && (
                <div className="line-btn-group">
                    <DeleteButtonIcon onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setOpenDelete(true);
                    }} />
                    <EditButtonIcon onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setOpenEdit(true);
                    }} />
                </div>            )}

            <DeleteModal
                type="тип партнера"
                name={partnerType.name}
                onDelete={() => {
                    onDelete(partnerType.id);
                    setOpenDelete(false);
                }}
                open={openDelete}
                setOpen={setOpenDelete}
            />

            <UpdateModal open={openEdit} setOpen={setOpenEdit}>
                <PartnerTypeForm                    submitting={false}
                                                    onSubmit={(e) => {
                                                        e.preventDefault();
                                                        onEdit(partnerType.id, editData);
                                                        setOpenEdit(false);
                                                    }}
                                                    partnerData={editData}
                                                    setPartnerData={setEditData}
                                                    errors={{}}
                                                    setOpen={setOpenEdit}
                />
            </UpdateModal>        </li>    );
};

const PartnersPage = () => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const workshopParam = searchParams.get('workshop');

    const [workshops, setWorkshops] = useState([]);
    const [selectedWorkshopValue, setSelectedWorkshopValue] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [openCreate, setOpenCreate] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [partnerData, setPartnerData] = useState({
        name: "",
        description: ""
    });
    const [errors, setErrors] = useState({
        name: "",
        description: ""
    });
    const [partnerTypes, setPartnerTypes] = useState([]);

    // Drag and drop states
    const [isEditMode, setIsEditMode] = useState(false);
    const [draggedItem, setDraggedItem] = useState(null);
    const [dragOverIndex, setDragOverIndex] = useState(null);
    const [isSaving, setIsSaving] = useState(false);

    const sortedWorkshops = useMemo(() => {
        return [...workshops].sort((a, b) => b.year - a.year);
    }, [workshops]);

    useEffect(() => {
        if (workshops.length > 0 && workshopParam) {
            const workshop = workshops.find(w => w.id.toString() === workshopParam);
            if (workshop) {
                setSelectedWorkshopValue([`${workshop.name} ${workshop.year}`]);
                loadPartnerTypes(workshop.id);
            }
        }
    }, [workshops, workshopParam]);

    useEffect(() => {
        if (dataCache.workshops) {
            setWorkshops(dataCache.workshops);
            handleInitialSelection(dataCache.workshops);
            setIsLoading(false);
            return;
        }

        axios
            .get(WORKSHOPS_INFO_ENDPOINT, getAcceptAuthConfig())
            .then((response) => {
                const workshopsData = response.data;
                dataCache.workshops = workshopsData;
                setWorkshops(workshopsData);
                handleInitialSelection(workshopsData);
            })
            .catch((error) => {
                console.error('Ошибка при получении данных мастерских:', error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    const handleInitialSelection = (workshopsData) => {
        if (workshopsData.length > 0) {
            if (workshopParam) {
                const workshop = workshopsData.find(w => w.id.toString() === workshopParam);
                if (workshop) {
                    setSelectedWorkshopValue([`${workshop.name} ${workshop.year}`]);
                    loadPartnerTypes(workshop.id);
                    return;
                }
            }

            const activeWorkshop = workshopsData.find(w => w.is_active) ||
                workshopsData.reduce((prev, current) =>
                    (prev.year > current.year) ? prev : current);
            setSelectedWorkshopValue([`${activeWorkshop.name} ${activeWorkshop.year}`]);
            loadPartnerTypes(activeWorkshop.id);
        }
    };

    const loadPartnerTypes = (workshopId) => {
        if (dataCache.partners.has(workshopId)) {
            setPartnerTypes(dataCache.partners.get(workshopId));
            return;
        }

        axios.get(PARTNERS_OF_WORKSHOP_ENDPOINT(workshopId), getAcceptAuthConfig())
            .then(response => {
                const partnerTypesData = response.data;
                dataCache.partners.set(workshopId, partnerTypesData);
                setPartnerTypes(partnerTypesData);
            })
            .catch(error => {
                console.error('Ошибка при загрузке типов партнеров:', error);
            });
    };

    const currentValue = selectedWorkshopValue[0] || '';
    const selectedWorkshop = workshops.find(w => `${w.name} ${w.year}` === currentValue);

    const handleAddPartnerType = (e) => {
        e.preventDefault();
        setSubmitting(true);

        const dataToSend = {
            ...partnerData,
            workshop: selectedWorkshop.id
        };

        axios.post(PARTNER_TYPES_ENDPOINT, dataToSend, getAcceptAuthConfig())
            .then(response => {
                if (selectedWorkshop) {
                    dataCache.partners.delete(selectedWorkshop.id);
                    loadPartnerTypes(selectedWorkshop.id);
                }
                setOpenCreate(false);
                setPartnerData({ name: "", description: "", order: 0 });
                setErrors({});
            })
            .catch(error => {
                setErrors(error.response?.data || {});
                console.error('Error creating partner type:', error);
            })
            .finally(() => {
                setSubmitting(false);
            });
    };

    const handleDeletePartnerType = (partnerTypeId) => {
        axios.delete(PARTNER_TYPES_DETAIL_ENDPOINT(partnerTypeId), getAcceptAuthConfig())
            .then(() => {
                if (selectedWorkshop) {
                    dataCache.partners.delete(selectedWorkshop.id);
                    loadPartnerTypes(selectedWorkshop.id);
                }
            })
            .catch(error => {
                console.error('Error deleting partner type:', error);
            });
    };

    const handleEditPartnerType = (partnerTypeId, data) => {
        axios.patch(PARTNER_TYPES_DETAIL_ENDPOINT(partnerTypeId), data, getAcceptAuthConfig())
            .then(() => {
                if (selectedWorkshop) {
                    dataCache.partners.delete(selectedWorkshop.id);
                    loadPartnerTypes(selectedWorkshop.id);
                }
            })
            .catch(error => {
                console.error('Error updating partner type:', error);
            });
    };

    // Drag and drop handlers
    const handleDragStart = (e, index) => {
        setDraggedItem(index);
        e.dataTransfer.effectAllowed = 'move';
        e.target.style.opacity = '0.5';
    };

    const handleDragEnd = (e) => {
        e.target.style.opacity = '1';
        setDraggedItem(null);
        setDragOverIndex(null);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';
    };

    const handleDragEnter = (e, index) => {
        e.preventDefault();
        setDragOverIndex(index);
    };

    const handleDrop = (e, dropIndex) => {
        e.preventDefault();

        if (draggedItem === null || draggedItem === dropIndex) {
            return;
        }

        const newPartnerTypes = [...partnerTypes];

        [newPartnerTypes[draggedItem], newPartnerTypes[dropIndex]] =
            [newPartnerTypes[dropIndex], newPartnerTypes[draggedItem]];

        setPartnerTypes(newPartnerTypes);
        setDraggedItem(null);
        setDragOverIndex(null);
    };

    const saveOrder = async () => {
        if (!selectedWorkshop) return;

        setIsSaving(true);

        try {
            const partnerTypeIds = partnerTypes.map(type => type.id);

            const response = await axios.post(
                PARTNER_TYPES_REORDER_ENDPOINT,
                {
                    workshop_id: selectedWorkshop.id,
                    partner_type_ids: partnerTypeIds
                },
                getAcceptAuthConfig()
            );

            // Update cache with new order
            dataCache.partners.set(selectedWorkshop.id, response.data);
            setPartnerTypes(response.data);
            setIsEditMode(false);

        } catch (error) {
            console.error('Ошибка при сохранении порядка:', error);
            // Reload original order in case of error
            if (selectedWorkshop) {
                dataCache.partners.delete(selectedWorkshop.id);
                loadPartnerTypes(selectedWorkshop.id);
            }
        } finally {
            setIsSaving(false);
        }
    };

    const cancelEdit = () => {
        setIsEditMode(false);
        // Reload original order
        if (selectedWorkshop) {
            dataCache.partners.delete(selectedWorkshop.id);
            loadPartnerTypes(selectedWorkshop.id);
        }
    };

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                <h1>Партнеры</h1>

                {selectedWorkshop && partnerTypes.length > 0 && (
                    <div className="edit-controls">
                        {!isEditMode ? (
                            <Button
                                view="outlined"
                                onClick={() => setIsEditMode(true)}
                            >
                                Изменить порядок
                            </Button>
                        ) : (
                            <div style={{ display: 'flex', gap: '8px' }}>
                                <Button                                    view="action"
                                                                           onClick={saveOrder}
                                                                           disabled={isSaving}
                                >
                                    {isSaving ? 'Сохранение...' : 'Сохранить'}
                                </Button>
                                <Button                                    view="normal"
                                                                           onClick={cancelEdit}
                                                                           disabled={isSaving}
                                >
                                    Отменить
                                </Button>
                            </div>                        )}
                    </div>
                )}
            </div>

            <hr className="clearfix w-100 pb-0"/>

            {isLoading ? (
                <LoadingSpinner/>
            ) : (
                <>
                    <div className="filters-column">
                        <div className="filter">
                            <label htmlFor="workshopFilter" style={{width: '100px'}}>Мастерская:</label>
                            <Select                                id="workshopFilter"
                                                                   placeholder={"Выберите мастерскую"}
                                                                   hasClear
                                                                   value={selectedWorkshopValue}
                                                                   onUpdate={(values) => {
                                                                       setSelectedWorkshopValue(values);
                                                                       setIsEditMode(false);
                                                                       if (values[0]) {
                                                                           const workshop = sortedWorkshops.find(w =>
                                                                               `${w.name} ${w.year}` === values[0]
                                                                           );
                                                                           if (workshop) {
                                                                               loadPartnerTypes(workshop.id);
                                                                           }
                                                                       } else {
                                                                           setPartnerTypes([]);
                                                                       }
                                                                   }}
                            >
                                {sortedWorkshops.map((workshop) => (
                                    <Select.Option
                                        key={workshop.id}
                                        value={`${workshop.name} ${workshop.year}`}
                                    >
                                        {workshop.name} {workshop.year}
                                    </Select.Option>
                                ))}
                            </Select>
                        </div>                    </div>
                    {!isEditMode && (
                        <AddButtonMaxWidth
                            className={"mb-3 mt-4"}
                            text={"Добавить тип партнера"}
                            onClick={() => setOpenCreate(true)}
                        />
                    )}

                    {isEditMode && (
                        <div style={{
                            backgroundColor: '#e3f2fd',
                            border: '1px solid #2196f3',
                            borderRadius: '8px',
                            padding: '12px',
                            margin: '16px 0',
                            color: '#1976d2'
                        }}>
                            <strong>Режим редактирования порядка:</strong> Перетащите элементы, чтобы изменить их порядок
                        </div>
                    )}

                    <ul className="list-unstyled mb-0">
                        {partnerTypes.map((partnerType, index) => (
                            <PartnerTypeItem
                                key={partnerType.id}
                                partnerType={partnerType}
                                workshopId={selectedWorkshop?.id}
                                onDelete={handleDeletePartnerType}
                                onEdit={handleEditPartnerType}
                                isEditMode={isEditMode}
                                index={index}
                                onDragStart={handleDragStart}
                                onDragEnd={handleDragEnd}
                                onDragOver={handleDragOver}
                                onDragEnter={handleDragEnter}
                                onDrop={handleDrop}
                                isDragOver={dragOverIndex === index}
                            />
                        ))}
                    </ul>

                    <UpdateModal open={openCreate} setOpen={setOpenCreate}>
                        <PartnerTypeForm                            submitting={submitting}
                                                                    onSubmit={handleAddPartnerType}
                                                                    partnerData={partnerData}
                                                                    setPartnerData={setPartnerData}
                                                                    errors={errors}
                                                                    setOpen={setOpenCreate}
                        />
                    </UpdateModal>                </>            )}
        </div>
    );
};

export default PartnersPage;